import React from 'react';
import PropTypes from 'prop-types';
import { CustomPropTypes } from '@beef/react';

/**
 * Abstract container that fires `onViewportEnter` once DOMElement by `domNodeRef` enters viewport for the first time
 */
var EnterViewportTracker = function EnterViewportTracker(props) {
  var domNodeRef = props.domNodeRef,
    children = props.children,
    onEnterViewport = props.onEnterViewport,
    inViewportTestFn = props.inViewportTestFn;
  function removeListeners() {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', handleScroll);
  }
  function handleScroll() {
    if (!inViewportTestFn(domNodeRef.current.getBoundingClientRect())) return;
    removeListeners();
    if (onEnterViewport) onEnterViewport();
  }
  React.useEffect(function () {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll();
    return removeListeners;
  }, []);
  return children;
};
EnterViewportTracker.propTypes = {
  /** takes boundingClientRect of domElement by `domNodeRef` */
  inViewportTestFn: PropTypes.func,
  domNodeRef: CustomPropTypes.ref.isRequired,
  onEnterViewport: PropTypes.func,
  children: PropTypes.node
};
EnterViewportTracker.defaultProps = {
  inViewportTestFn: function inViewportTestFn(_ref) {
    var top = _ref.top,
      bottom = _ref.bottom;
    return top >= 0 && bottom <= window.innerHeight;
  }
};
export default EnterViewportTracker;